import * as types from '../constants/officeRunnerConstants'

export default function positions(state = [], action) {
  switch (action.type) {
    case types.FETCH_POSITIONS_SUCCESS:
      // API returns duplicate positions. Filter those here. Ideally we figure out why the API
      // returns duplicates (parameters?). But that's too much effort for now.
      return [
        ...new Map(action.positions.map((x) => [x.position_id, x])).values(),
      ]
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/positionsReducer.js